import { url } from '../utils/config';
import axios from "axios";
import Table from "../reusable_components/Table";
import { toast } from "react-toastify";
import { btnGreen, btnRed, title } from '../utils/style';
import moment from "moment";


function EquipmentReservationRequest() {


    function approveReservationRequest(id) {
        const reqUrl = url + `/approve_equipment_reservation/${id}`;
        const token = window.localStorage.getItem('token');
        const headers = { authorization: `bearer ${token}` };
        axios.get(reqUrl, { headers })
        .then(res => toast.success(res.data.message, { autoClose: 3000 }))
        .catch(err => toast.error(err.response.data.message, { autoClose: 3000 }))
    }

    function rejectReservationRequest(id) {
        const reqUrl = url + `/reject_equipment_reservation/${id}`;
        const token = window.localStorage.getItem('token');
        const headers = { authorization: `bearer ${token}` };
        axios.get(reqUrl, { headers })
        .then(res => toast.success(res.data.message, { autoClose: 3000 }))
        .catch(err => toast.error(err.response.data.message, { autoClose: 3000 }))
    }

    const options = [
        {
            header: 'REQUESTED BY',
            key: 'technicianName',
        },
        {
            header: 'EQUIPMENT',
            key: 'special_equipment_id',
        },
        {
            header: 'DATE',
            key: 'date',
            placeHolder: 'mm-dd-yyyy'
        },
        {
            header: 'CHECK-IN TIME',
            key: 'checkinTime',
        },
        {
            header: 'CHECK-OUT TIME',
            key: 'checkoutTime',
        },
        {
            header: 'ACTION',
            render: (data) => {
                return(
                    <>
                        <span 
                            className={btnGreen}
                            onClick={() => approveReservationRequest(data.id)}
                        >
                            Approve
                        </span>
                        <span 
                            className={btnRed}
                            onClick={() => rejectReservationRequest(data.id)}
                        >
                            Reject
                        </span>
                    </>
                )
            },
        },
    ]

    const excludeFilter = ['ACTION']

    return(
        <div className="p-4">
            <div className={`${title} mb-4`}>Equipment Reservation Requests</div>
            
            <Table 
                options={options} 
                url={url + '/equipment_reservations'} 
                pagination 
                noButton
                excludeFilter={excludeFilter}
            />
        </div>
    )
}

export default EquipmentReservationRequest;